// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"Container_skillContainer__1RJD1","heading":"Container_heading__40PPr","years":"Container_years__E9ayb"};